const state = {
  modules: [],
  nowActiveNav: 0,
};
const mutations = {
  increment(state, modules) {
    state.modules = modules;
  },
  setNowActiveNav(state, num) {
    state.nowActiveNav = num;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
};
